import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import useCategoryHook from "@/shared/hooks/useCategoryHook";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import { FormProvider, useForm } from "react-hook-form";
import VatPerTarget from "../VatPerTarget";
import { cleanCharFromObject } from "@/shared/utils/helpers";

const MenuFastVats = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const operationRef = useRef<"add" | "remove">();
  const { productPatch } = useCategoryHook();
  const [{ parentId }] = useModalMeta();
  const setModal = useSetModal();
  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    productPatch.mutateAsync(
      {
        data: {
          vat_enum_per_target: cleanCharFromObject(data.vat_enum_per_target),
          method: operationRef.current,
        },
        categoryId: parentId,
        type: "vats",
      },
      { onSuccess: () => setModal("", {}) }
    );
  };

  return (
    <Modal {...props} onExit={onExit}>
      <FormProvider {...methods}>
        <form id="menu-fast-btw" onSubmit={handleSubmit(onSubmit)}>
          <VatPerTarget data={{}} />
        </form>
      </FormProvider>

      <div className="mt-20 flex gap-4">
        <Button
          isPending={productPatch.isPending}
          style={{ width: "50%" }}
          variant="danger"
          form="menu-fast-btw"
          onClick={() => (operationRef.current = "remove")}
        >
          {t("menu.remove")}
        </Button>
        <Button
          isPending={productPatch.isPending}
          style={{ width: "50%" }}
          form="menu-fast-btw"
          onClick={() => (operationRef.current = "add")}
        >
          {t("menu.add")}
        </Button>
      </div>
    </Modal>
  );
};

export default MenuFastVats;
